<template>
    <vx-card class="limited-max-width" id="social-security">
      <div>
        <header-step-process-component
          v-bind:step="step">
        </header-step-process-component>

          <span class="title-style modify-title" style="display:inline-block; margin-bottom:8px">Prestaciones y pérdida de ingresos por enfermedad común.</span>
          <span class="subtitle-style modify-subtitle" style="display:inline-block; opacity: 0.7;">
            En este gráfico mostramos los importes aproximados que percibirías, así como la pérdida de ingresos. 
            Lo que figura en rojo es lo que te recomendamos asegurar.
          </span>
          

          <div v-if="commercialOffer.type == 'SOCIALSECURITY'">
          <commercial-offer-social-security
            v-bind:commercialOffer="commercialOffer"
            v-bind:code="code"
            v-bind:next="next"
            v-bind:previus="previus"
          >
          </commercial-offer-social-security>
        </div>
      </div>
    </vx-card>
</template>

<script>
/* eslint-disable */
import VxCard from '../../components/vx-card/VxCard.vue'
import CoverageChartComponent from '../components/eprevision-components/coverage-chart/CoverageChartComponent.vue';
import HeaderStepProcessComponent from '../components/eprevision-components/header/HeaderStepProcessComponent.vue';
import FormsRepository from '../forms/e-prevision-forms/forms-repository.vue';
import InsuredForm from '../forms/e-prevision-forms/InsuredForm/InsuredForm.vue';
import CommercialOfferSocialSecurity from '../components/eprevision-components/commercialOfferSocialSecurity/CommercialOfferSocialSecurity.vue'
import axios from '../../http/axios/index.js'
export default {
  components: {
      VxCard,
      FormsRepository,
      InsuredForm,
      HeaderStepProcessComponent,
      CoverageChartComponent,
      CommercialOfferSocialSecurity
    },
    data() {
      return {
        step: 2,
        code: this.$route.params.code,
        next: "social-security/third",
        previus: "social-security/first",
        dataStored: null,
        commercialOffer: null,

      }
    },
    created() {
      this.$vs.loading.close()

      this.dataStored = JSON.parse(localStorage.getItem(this.code))
      this.commercialOffer = this.dataStored.commercialOffer
    },

}
</script>
